import React from "react"
// import Router from "./Router"
const Router = React.lazy(() => import('./Router'));

// import "./components/@vuexy/rippleButton/RippleButton"
// import "react-perfect-scrollbar/dist/css/styles.css"
// import "prismjs/themes/prism-tomorrow.css"
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
const GoogleReCaptchaProvider = React.lazy(() => import('./CaptchaAndHeaders'));//lazy load of css, button and default captcha in an extra file because lazy works on default exports only
const CONFIG = require('./config-front')

// import { TYPE_OF_THEME } from './enum';

//STEP 1:
//create components using React.lazy
const CustomerTheme = React.lazy(() => import('./themes/customerTheme'));
const CenterTheme = React.lazy(() => import('./themes/centerTheme'));
// const DarkTheme = React.lazy(() => import('./themes/darkTheme'));
// console.log("Tipo de tema",TYPE_OF_THEME)
//STEP 2:
//create a parent component that will load the components conditionally using React.Suspense
const ThemeSelector = ({ children }) => {
  var theme;
  // console.log(window.location.pathname, window.location.pathname.localeCompare('/') === 0, window.location, window.location.pathname.localeCompare(""))
  // const CHOSEN_THEME = localStorage.getItem('TYPE_OF_THEME') || TYPE_OF_THEME.DEFAULT;
  if(window.location.href.includes("/customer/") || window.location.pathname.localeCompare("/") === 0)
  theme =  "CUSTOMER_MODE"
  
  if(window.location.href.includes("/center/"))
  theme =  "CENTER_MODE"
  
  return (
    <>
      <React.Suspense fallback={<></>}>
        {/* {(CHOSEN_THEME === TYPE_OF_THEME.CUSTOMER_MODE) && <CustomerTheme />} */}
        {(theme === "CUSTOMER_MODE") && <CustomerTheme />}

        {(theme === "CENTER_MODE") && <CenterTheme />}

        {/* {(CHOSEN_THEME === TYPE_OF_THEME.DARK_MODE) && <DarkTheme />} */}
      </React.Suspense>
      {children}
    </>
  )
}

//STEP 3
//wrap the main components inside of the ThemeSelector

const App = props => {
  return   <ThemeSelector>
            <GoogleReCaptchaProvider
              reCaptchaKey={CONFIG.captchaTokenFront}
              language="es-ES"
              useRecaptchaNet={false}
              useEnterprise={false}
              scriptProps={{
                async: false, // optional, default to false,
                defer: false, // optional, default to false
                appendTo: "head", // optional, default to "head", can be "head" or "body",
                nonce: undefined // optional, default undefined
              }}
            >
            <Router />
            </GoogleReCaptchaProvider>
          </ThemeSelector>
}

export default App
